import { render, staticRenderFns } from "./tlQa.vue?vue&type=template&id=de7f2fb0&scoped=true&"
import script from "./tlQa.vue?vue&type=script&lang=js&"
export * from "./tlQa.vue?vue&type=script&lang=js&"
import style0 from "./tlQa.vue?vue&type=style&index=0&id=de7f2fb0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7f2fb0",
  null
  
)

export default component.exports